<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-record-stop`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zm0 4C14.059 6 6 14.059 6 24s8.059 18 18 18 18-8.059 18-18S33.941 6 24 6zm4.2 11a2.8 2.8 0 012.8 2.8v8.4a2.8 2.8 0 01-2.8 2.8h-8.4a2.8 2.8 0 01-2.8-2.8v-8.4a2.8 2.8 0 012.8-2.8h8.4z"/></svg>
</template>
<script>

export default {
  name: 'IconRecordStop',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
